import React from "react";

import { patientBoardItemStatus } from "./statusLabelColor";

import trash from "../../assets/icons/trash.png";
import call from "../../assets/icons/call.png";
import sms from "../../assets/icons/sms3.svg";

export default function BoardColumnItem({ onDelete, status, patientData, setClickedPatientId }) {
  const { statusColor, statusBackgroundColor } = patientBoardItemStatus(status);

  const handleDelete = (e) => {
    e.stopPropagation(); // Prevent triggering the parent onClick
    onDelete(patientData.id);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 10,
        border: "1px solid #F0F0F0",
        cursor: "pointer",
        backgroundColor: "white",
        borderRadius: 8,
        padding: "10px 15px",
      }}
      onClick={() => setClickedPatientId(patientData.id)}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <p style={{ marginBottom: 0, fontSize: 14, fontWeight: 400 }}>
          {patientData.first_name} {patientData.last_name}
        </p>

        <div style={{ display: "flex", alignItems: "center", gap: 7 }}>
          {status !== null && (
            <span
              style={{
                backgroundColor: statusBackgroundColor,
                color: statusColor,
                padding: "2px 9px",
                borderRadius: 100,
                fontSize: 10,
                textTransform: "capitalize",
              }}
            >
              {status}
              {/* {patientData.status} */}
            </span>
          )}

          {status !== "processing" && (
            <img src={trash} style={{ width: 18, height: 18 }} alt="remove" className="mouse-hover" onClick={handleDelete} />
          )}
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
          <img src={call} alt="phone" />
          <span style={{ color: "#848696", fontSize: 12 }}>{patientData.phone}</span>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
          <img src={sms} alt="phone" />
          <span style={{ color: "#848696", fontSize: 12 }}>{patientData.email}</span>
        </div>
      </div>
    </div>
  );
}
